import {gql} from 'apollo-boost';

export const favoritesQuery = gql`
    query FavoritesQuery {
        favorites {
            productId
        }
    }
`;
